import React from 'react';
import { observer } from 'mobx-react';

import { Form } from 'libs/forms/index';

import { Modal } from 'apps/modals/views/modal';
import { modalStore } from 'apps/modals/app';

@observer
export class EditManufaturerInfoForm extends Modal {
  render() {
    const { manager } = modalStore.props;
    const { editManufacturerInfoForm } = manager;
    return (
      <Form
        formStore={editManufacturerInfoForm}
        buttonHandler={manager.SaveManufacturer}
        formTitleCentered={true}
        noBorder={true}
      />
    );
  }
}
